import React from "react";
import smoothscroll from "smoothscroll-polyfill";
import { GlobalStyles } from "../GlobalStyles/GlobalStyles";
import MainSection from "../сomponents/MainSection/MainSection";
import { SectionsObserver } from "../сomponents/sectionsObserver/SectionsObserver";
import Footer from "../сomponents/Footer/Footer";
import Seo from "../сomponents/seo";

export default function Home() {
  typeof window !== "undefined" && smoothscroll.polyfill();
  return (
    <>
      <Seo />
      <GlobalStyles />
      <MainSection />
      <SectionsObserver />
      <Footer />
    </>
  );
}
